export default __webpack_public_path__ + "static/media/logo.54cac19c.svg";